import * as ROUTES from '../common/routes';
import React from 'react';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import CircularProgress from '@mui/material/CircularProgress';
import clsx from 'clsx';

interface IProps {
  onClick?: (event: React.SyntheticEvent) => void;
  isProgress?: boolean;
  text?: string;
  className?: any;
  disabled?: boolean;
}

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      buttonStyle: {
        minWidth: '190px',
        height: '50px',
        maxHeight: '50px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: COLORS.white,
        background: COLORS.appButtonsGray,
        borderRadius: '8px',
        '& > span': {
          width: '20px !important',
          height: '20px !important',
        },
        '& > span > svg': {
          color: COLORS.white,
        },
      },
      additionalButtonStyle: {
        whiteSpace: 'nowrap',
        padding: '0 14px',
        fontWeight: FONT_WEIGHT.medium,
        fontSize: '16px',
        fontFamily: FONTS.alegreya,
        lineHeight: '39px',
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            color: COLORS.appBlack,
            background: COLORS.appMenuHoverSand,
            transition: '0.5s ease',
            outline: `1px solid ${COLORS.appButtonsGray}`,
          },
        },
      },
      disabledStyle: {
        pointerEvents: 'none',
        background: COLORS.circleGray,
        color: COLORS.textGray,
      },
    })
);

const Button = ({
  onClick,
  isProgress,
  text,
  className,
  disabled,
}: IProps): JSX.Element => {
  const classes = useStyles();

  if (isProgress) {
    return (
      <div className={clsx(classes.buttonStyle, className)}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div
      className={clsx(
        classes.buttonStyle,
        classes.additionalButtonStyle,
        className,
        disabled && classes.disabledStyle
      )}
      onClick={onClick}
    >
      {text}
    </div>
  );
};

export default Button;
